<template>
  <el-form :model="form" :rules="rules" ref="form" v-loading="isLoading">

    <p>Referente a sede da empresa</p>
    <ul>
      <li>IPTU ou Habite-se do Imóvel onde será a sede da empresa;</li>
      <li>Cópia do Contrao de Locação se for o caso</li>
    </ul>
    <br>
    
    <p>Documentos do(s) empresário, sócio(s), presidente, titular:</p>
    <ul>
      <li>Cópia da Identidade (RG);</li>
      <li>CPF;</li>
      <li>Comprovante de Residência</li>
    </ul>

    <el-form-item prop="arquivos">
      <el-upload action="https://cdn.icnex.com/formularios12/?arquivos&adicionar" :on-success="onSuccess" :on-error="onError" :before-upload="beforeUpload" :on-remove="onRemove" :file-list="form.arquivos">
        <el-button type="primary" :disabled="disableField">Clique aqui para fazer o upload</el-button>
      </el-upload>
    </el-form-item>

    <br>

    <h3>Validação para poder enviar a solicitação</h3>

  </el-form>
</template>

<script>
export default {
  props: ['form'],

  data () {
    return {
      isLoading: false,
      disableField: false,
      fileAlreadyUploaded: false,
      rules: {
        arquivos: [
          { type: 'array', required: true, message: 'Você precisa anexar no mínimo 4 anexos (Documentos mínimos)', min: 4 }
        ]
      }
    }
  },

  methods: {
    onRemove (file, arquivos) {
      if (!this.fileAlreadyUploaded) {
        this.$http.headers.common['Access-Control-Allow-Origin'] = '*'
        this.$http.post('https://cdn.icnex.com/formularios12/?arquivos&remover', file)
          .then(response => {
            if (response.ok && response.body === true) {
              this.form.arquivos.splice(this.form.arquivos.indexOf(file), 1)
            }
          })
      }

      this.fileAlreadyUploaded = false
    },

    onSuccess (response, file, files) {
      this.disableField = false
      this.form.arquivos.push(file)
    },

    onError (err, file, fileList) {
      console.log(err)
    },

    beforeUpload (file) {
      this.disableField = true

      const dontExistsYet = this.form.arquivos.every(arquivo => arquivo.name !== file.name && arquivo.lastModified !== file.lastModified)

      if (!dontExistsYet) {
        this.fileAlreadyUploaded = true
        this.$message({ message: 'Você já adicionou esse arquivo' })
      }

      const extensions = ['image/jpeg', 'image/png', 'application/pdf', 'text/plain', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword', 'text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
      const validExtension = extensions.includes(file.type)

      const smallerThan5Mb = file.size / 1024 / 1024 < 5

      if (!validExtension) {
        this.$message({ type: 'error', message: 'A extensão do arquivo não é válida' })
      }

      if (!smallerThan5Mb) {
        this.$message({ type: 'error', message: 'O arquivo não pode ser maior que 5mb' })
      }

      return dontExistsYet && validExtension && smallerThan5Mb
    }
  }
}
</script>



// WEBPACK FOOTER //
// DocumentosNecessarios.vue?74d9c7d4